import UserStoreModule from '../../user/store/module';

export default function isSuspendedSubscription(): boolean {
  return UserStoreModule.data?.store?.subscription?.is_suspended ?? false;
}
